import {Routes} from '@angular/router';
import {globalRoutes} from './section-global/global.routes';
import {authGuard} from '../../sdk/src/guards/auth-guard.guard';
import {GlobalLayoutComponent} from './section-global/global-layout.component';
import {NotFoundPageComponent} from './section-global/not-found-page/not-found-page.component';
import {customerRoutes} from './section-customer/customer.routes';

export const routes: Routes = [
    ...globalRoutes,
    ...customerRoutes,
    {
        path: '**',
        pathMatch: 'full',
        canActivate: [authGuard],
        data: {noAuthorization: true, noUser: true},
        component: GlobalLayoutComponent,
        children: [
            {
                path: '',
                component: NotFoundPageComponent
            }
        ]
    }
];
